import React, { memo, MutableRefObject } from 'react';
import { useAppSelector } from 'store';
import { PositionConnection } from '../PositionConnection/PositionConnection';

interface ConnectionsProps {
    classes?: string;
    diagramRef: MutableRefObject<null>;
}

export const Connections = memo(({ classes, diagramRef }: ConnectionsProps) => {
    const { connections } = useAppSelector((state) => state.positionsConnectionsReducer);

    return (
        <>
            {connections.map((connection) => (
                <PositionConnection
                    diagramRef={diagramRef}
                    key={connection.from + connection.to + connection.type}
                    connection={connection}
                />
            ))}
        </>
    );
});
